export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13351.cf2a336e.jpg";